<div class="main-loader" *ngIf="showLoader">
  <div class="inner-loader">
    <img
      src="assets/images/uib-loader.avif"
      style="width: 150px !important"
      alt=""
    />
    <div *ngIf="signupMessage" style="padding-top: 40px">
      Kindly wait a moment while your account is being configured.
    </div>
  </div>
</div>
